var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvoidMotorwaysMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 4,
    width: 2,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.5537109,20 30.2203979,4 28.1129761,4 33.4462891,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.8870239,4 17.7796021,4 12.4462891,20 14.5537109,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,22 0,24 4,24 4,28 6,28 6,24 11.1129761,24 4.4462891,44 6.5537109,44 13.2203979,24 23,24 23,44 25,44 25,24  34.7796021,24 41.4462891,44 43.5537109,44 36.8870239,24 42,24 42,28 44,28 44,24 48,24 48,22  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvoidMotorwaysMedium);
export default __webpack_public_path__ + "static/media/avoid-motorways--medium.7afbfb208c0a8623aef2fbe4685ef7c5.svg";
export { ForwardRef as ReactComponent };